module.exports = "<p>\n  revised-drawing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/revised-drawing/revised-drawing.component.html
// module id = ./src/app/planning/revised-drawing/revised-drawing.component.html
// module chunks = main